import { ObjectSchema } from 'yup';

import { ERROR_DICTIONARY, ERRORS } from '../../../../../utils/errorDictionary';
import yup from '../../../../../utils/yup';

import { AUTH_FIELDS } from './constants';

export type TAuthFormInputs = {
  [AUTH_FIELDS.NAME]: string;
  [AUTH_FIELDS.AGREEMENT]: boolean;
  [AUTH_FIELDS.CODE]: string;
  [AUTH_FIELDS.EMAIL]: string;
  [AUTH_FIELDS.PHONE]: string;
};

type TSchemaParams = {
  isCodeSent: boolean;
};

export const createSchema = ({ isCodeSent }: TSchemaParams): ObjectSchema<TAuthFormInputs> =>
  yup.object().shape({
    [AUTH_FIELDS.NAME]: yup.string().trim().required(ERROR_DICTIONARY[ERRORS.REQUIRED_FIELD]).name(),

    [AUTH_FIELDS.EMAIL]: yup
      .string()
      .email(ERROR_DICTIONARY[ERRORS.INVALID_EMAIL_ADDRESS])
      .required(ERROR_DICTIONARY[ERRORS.REQUIRED_FIELD]),

    [AUTH_FIELDS.PHONE]: yup
      .string()
      .required(ERROR_DICTIONARY[ERRORS.REQUIRED_FIELD])
      .normalizePhone()
      .mobilePhone(ERROR_DICTIONARY[ERRORS.INVALID_PHONE]),

    [AUTH_FIELDS.AGREEMENT]: yup.boolean().isTrue(ERROR_DICTIONARY[ERRORS.REQUIRED_FIELD]),

    [AUTH_FIELDS.CODE]: isCodeSent
      ? yup.string().required(ERROR_DICTIONARY[ERRORS.REQUIRED_FIELD]).length(4, '').numeric()
      : yup.string(),
  });
